module.exports = __webpack_public_path__ + "img/cover-manpower.3ba7e4f9.jpg";